import React from "react";

const WhyChooseUs = () => {
  const content = [
    {
      heading: "Unique Flavors",
      para: "Experience traditional African spices and marinades that offer a one-of-a-kind BBQ taste.",
      icon: "fas fa-fire",
    },
    {
      heading: "Quality Ingredients",
      para: "We prioritize fresh, locally sourced ingredients, ensuring a high-quality dining experience.",
      icon: "fas fa-carrot",
    },
    {
      heading: "Diverse Menu",
      para: "From rich, savory meats to delectable side dishes, there's something for everyone.",
      icon: "fas fa-utensils",
    },
    {
      heading: "Cultural Experience",
      para: "Enjoy not just a meal, but a cultural journey through the diverse cuisines of Africa.",
      icon: "fas fa-globe",
    },
  ];
  return (
    <section className="about_choose mt_100 xs_mt_70 mb_100 xs_mb_70">
      <div className="container">
        <div className="row align-items-center">
          <div
            // className="col-xxl-8 col-lg-7 wow fadeInLeft"
            className="col-xxl-12 col-lg-12 wow fadeInLeft"
            data-wow-duration="1s"
          >
            <div className="section_heading mb_25">
              <h4 className="fs-2">Why choose us</h4>
              {/* <h2>Why we are the best</h2> */}
            </div>
            <div className="about_choose_text">
              <p className="fs-5">
                Afrikan BBQ LLC is your premier choice for authentic African
                barbecue in Spokane, WA, for several compelling reasons. We take
                pride in delivering a unique and unparalleled culinary
                experience by blending traditional African flavors with modern
                cooking techniques. Our commitment to using fresh, locally
                sourced ingredients ensures top-quality dishes every time.
                Additionally, we value community engagement and strive to bring
                people together through the rich and vibrant culture our food
                represents. With our exceptional service, attention to detail,
                and passion for sharing authentic African cuisine, Afrikan BBQ
                LLC stands out as the best destination for a memorable BBQ
                experience in Spokane. Thanks For Choosing Afrikan BBQ. We look
                forward to serving you and sharing the rich flavor of African
                here in Spokane, WA.
              </p>
              <div className="row">
                {content.map((e, i) => (
                  <div className="col-xl-6">
                    <div className="about_choose_text_box">
                      <span>
                        <i className={e?.icon} />
                      </span>
                      <h4 className="fs-4">{e?.heading}</h4>
                      <p className="fs-6">{e?.para}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* <div
            className="col-xxl-4 col-lg-5 wow fadeInRight"
            data-wow-duration="1s"
          >
            <div className="about_choose_img">
              <img
                src="images/why_choose_img.png"
                alt="about us"
                className="img-fluid w-100"
              />
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
